import { Box, Button, Typography, useTheme } from "@mui/material";
import React from "react";
import ArrowLeftSVG from "../../../../media/images/icons/arrow-left";
import MenuIcon from "../../../../media/images/icons/hambergerMeno.svg";
import LogoImage from "../../../../media/images/icons/logo.svg";
import NavBackButton from "../../../components/NavBackButton";
import HamMenuIcon from "../../../../media/images/icons/hambergerMenu";
import ArrowTickLeft from "../../../../media/images/icons/arrow-tick-left.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../hooks/useRedux";
import { setOpenAuthSidebar } from "../../../../redux/features/settingSlice";

interface Props {
  hasScroll: boolean;
  title: string;
}

export default function MobileHeader({ hasScroll, title }: Props) {
  const theme = useTheme();
  const navigate = useNavigate();
  const { loginGrids, signupGrids } = useAppSelector((state) => state.setting);
  const dispatch = useAppDispatch();
  return (
    <Box
      sx={{
        backgroundColor: hasScroll ? "background.paper" : "",
        boxShadow: hasScroll ? "0px 4px 15px 3px rgba(0,0,0,0.1)" : "none",
        zIndex: 20,
        transition: "box-shadow 500ms",
        width: "100%",
        display: {
          xs: "flex",
          md: "none",
          padding: "8px",
        },
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        <NavBackButton goBack={() => navigate(-1)} />
        <Button
          onClick={() => dispatch(setOpenAuthSidebar(true))}
          sx={{
            minWidth: "0px",
            padding: "8px",
            border: "1px solid gray",
            borderRadius: "8px",
            borderColor: `${theme.palette.secondary.main} !important`,
            backgroundColor: `${theme.palette.secondary.light} !important`,
            "& .MuiTouchRipple-root": {
              color: `${theme.palette.secondary.main} !important`,
              borderWidth: "0px !important",
            },
            "& .MuiButtonBase-root": {
              color: `${theme.palette.secondary.main} !important`,
              borderWidth: "0px !important",
            },
          }}
        >
          <HamMenuIcon size={20} color={theme.palette.secondary.dark} />
        </Button>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            color: "secondary.main",
            fontWeight: 600,
          }}
        >
          کارن ترابرنت
        </Typography>
        <img src={ArrowTickLeft} alt="" />
        <Typography
          sx={{
            color: "secondary.main",

            fontSize: "12px",
            fontWeight: 600,
          }}
        >
          {title}
        </Typography>
      </Box>
    </Box>
  );
}
